exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".arrow_drop_down {\n  flex: 1;\n  border: black 0.037rem solid !important;\n  border-radius: 0.25rem;\n  width: 100%;\n}\n.arrow_drop_down .ant-select-selector {\n  height: 4.375rem !important;\n  border: 0rem !important;\n  padding: 1.25rem 1.625rem !important;\n  width: 100%;\n  color: black;\n}\n", ""]);

